import React from 'react';
import Divider from '../Common/Divider';
import * as S from './styled';

export default function Footer() {
  return (
    <footer>
      <Divider />
      <S.Wrapper>
        <S.Link to="/about">About TFT Synergies</S.Link>
        <S.Contribute
          as="a"
          href="https://github.com/evandromacedo/tft-synergies"
          target="_blank"
        >
          <span>Contribute on GitHub</span>
          <GitHubIcon />
        </S.Contribute>
      </S.Wrapper>
    </footer>
  );
}

function GitHubIcon() {
  return (
    <svg width={24} height={24}>
      <defs>
        <linearGradient x1="49.991%" y1="105.3%" x2="49.991%" y2=".057%" id="prefix__a">
          <stop stopColor="#67502D" offset="0%" />
          <stop stopColor="#D8A75B" offset="99.982%" />
        </linearGradient>
      </defs>
      <path
        d="M22.39 6.126a12.102 12.102 0 00-4.367-4.476C16.185.55 14.177 0 12 0 9.823 0 7.815.55 5.977 1.65a12.1 12.1 0 00-4.368 4.476C.536 8.011 0 10.07 0 12.3c0 2.68.763 5.091 2.289 7.232 1.526 2.14 3.497 3.622 5.914 4.444.281.054.49.016.625-.112a.634.634 0 00.203-.48l-.008-.865c-.005-.544-.008-1.02-.008-1.425l-.36.064c-.228.043-.517.061-.866.056a6.45 6.45 0 01-1.086-.112 2.398 2.398 0 01-1.047-.48 2.031 2.031 0 01-.688-.985l-.156-.369a4.021 4.021 0 00-.492-.817c-.224-.299-.45-.501-.68-.608l-.109-.08a1.158 1.158 0 01-.203-.193.882.882 0 01-.14-.224c-.032-.075-.006-.136.078-.185.083-.048.234-.071.453-.071l.312.048c.208.043.466.17.773.384.308.214.56.491.758.833.24.438.529.771.867 1 .339.23.68.345 1.024.345.343 0 .64-.027.89-.08.25-.053.485-.133.703-.24.094-.716.35-1.266.766-1.65a10.462 10.462 0 01-1.602-.288 6.29 6.29 0 01-1.468-.625 4.233 4.233 0 01-1.258-1.073c-.333-.427-.607-.988-.82-1.682-.214-.694-.32-1.495-.32-2.402 0-1.293.411-2.392 1.234-3.3-.386-.972-.35-2.06.11-3.267.301-.096.75-.024 1.343.216.594.24 1.029.446 1.305.617.276.17.497.315.664.432a10.84 10.84 0 013-.416c1.03 0 2.031.139 3 .416l.594-.384a8.321 8.321 0 011.437-.705c.552-.213.974-.272 1.266-.176.469 1.207.51 2.296.125 3.267.823.908 1.234 2.008 1.234 3.3 0 .907-.107 1.71-.32 2.41-.213.7-.49 1.26-.828 1.682-.339.422-.76.777-1.266 1.065a6.303 6.303 0 01-1.468.625c-.474.128-1.008.224-1.602.288.542.48.812 1.239.812 2.274v3.38c0 .192.065.352.196.48.13.128.336.165.617.112 2.417-.822 4.388-2.304 5.914-4.445C23.237 17.391 24 14.981 24 12.3c0-2.231-.537-4.289-1.61-6.174z"
        fill="url(#prefix__a)"
        fillRule="nonzero"
      />
    </svg>
  );
}
